import {
  useMutation,
  useQuery
} from '@tanstack/vue-query'
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationReturnType,
  UseQueryOptions,
  UseQueryReturnType
} from '@tanstack/vue-query'
import {
  unref
} from 'vue'
import type {
  MaybeRef
} from 'vue'
import type {
  ApiGetBidsParams,
  BackendErrorEntity,
  CancelBidResponseDto,
  GetBidsResponseDto,
  PlaceBidBodyDto,
  PlaceBidResponseDto
} from '.././types'
import { fetchApiInstance } from '../../fetchApiInstance';
import type { ErrorType, BodyType } from '../../fetchApiInstance';


type SecondParameter<T extends (...args: any) => any> = Parameters<T>[1];


export const apiPlaceBid = (
    placeBidBodyDto: MaybeRef<PlaceBidBodyDto>,
 options?: SecondParameter<typeof fetchApiInstance>,) => {
      placeBidBodyDto = unref(placeBidBodyDto);
      
      return fetchApiInstance<PlaceBidResponseDto>(
      {url: `/bids`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: placeBidBodyDto
    },
      options);
    }
  


export const getApiPlaceBidMutationOptions = <TError = ErrorType<BackendErrorEntity>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiPlaceBid>>, TError,{data: BodyType<PlaceBidBodyDto>}, TContext>, request?: SecondParameter<typeof fetchApiInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof apiPlaceBid>>, TError,{data: BodyType<PlaceBidBodyDto>}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiPlaceBid>>, {data: BodyType<PlaceBidBodyDto>}> = (props) => {
          const {data} = props ?? {};

          return  apiPlaceBid(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ApiPlaceBidMutationResult = NonNullable<Awaited<ReturnType<typeof apiPlaceBid>>>
    export type ApiPlaceBidMutationBody = BodyType<PlaceBidBodyDto>
    export type ApiPlaceBidMutationError = ErrorType<BackendErrorEntity>

    export const useApiPlaceBid = <TError = ErrorType<BackendErrorEntity>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiPlaceBid>>, TError,{data: BodyType<PlaceBidBodyDto>}, TContext>, request?: SecondParameter<typeof fetchApiInstance>}
): UseMutationReturnType<
        Awaited<ReturnType<typeof apiPlaceBid>>,
        TError,
        {data: BodyType<PlaceBidBodyDto>},
        TContext
      > => {

      const mutationOptions = getApiPlaceBidMutationOptions(options);

      return useMutation(mutationOptions);
    }
    export const apiGetBids = (
    params?: MaybeRef<ApiGetBidsParams>,
 options?: SecondParameter<typeof fetchApiInstance>,) => {
      params = unref(params);
      
      return fetchApiInstance<GetBidsResponseDto>(
      {url: `/bids`, method: 'GET',
        params: unref(params)
    },
      options);
    }
  

export const getApiGetBidsQueryKey = (params?: MaybeRef<ApiGetBidsParams>,) => {
    return ['bids', ...(params ? [params]: [])] as const;
    }

    
export const getApiGetBidsQueryOptions = <TData = Awaited<ReturnType<typeof apiGetBids>>, TError = ErrorType<BackendErrorEntity>>(params?: MaybeRef<ApiGetBidsParams>, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof apiGetBids>>, TError, TData>, request?: SecondParameter<typeof fetchApiInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getApiGetBidsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiGetBids>>> = () => apiGetBids(params, requestOptions);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof apiGetBids>>, TError, TData> 
}

export type ApiGetBidsQueryResult = NonNullable<Awaited<ReturnType<typeof apiGetBids>>>
export type ApiGetBidsQueryError = ErrorType<BackendErrorEntity>



export function useApiGetBids<TData = Awaited<ReturnType<typeof apiGetBids>>, TError = ErrorType<BackendErrorEntity>>(
 params?: MaybeRef<ApiGetBidsParams>, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof apiGetBids>>, TError, TData>, request?: SecondParameter<typeof fetchApiInstance>}

  ): UseQueryReturnType<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getApiGetBidsQueryOptions(params,options)

  const query = useQuery(queryOptions) as UseQueryReturnType<TData, TError> & { queryKey: QueryKey };

  query.queryKey = unref(queryOptions).queryKey as QueryKey;

  return query;
}



export const apiCancelBid = (
    id: MaybeRef<string | undefined | null>,
 options?: SecondParameter<typeof fetchApiInstance>,) => {
      id = unref(id);
      
      return fetchApiInstance<CancelBidResponseDto>(
      {url: `/bids/${id}/cancel`, method: 'PATCH'
    },
      options);
    }
  


export const getApiCancelBidMutationOptions = <TError = ErrorType<BackendErrorEntity>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiCancelBid>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof fetchApiInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof apiCancelBid>>, TError,{id: string}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiCancelBid>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  apiCancelBid(id,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ApiCancelBidMutationResult = NonNullable<Awaited<ReturnType<typeof apiCancelBid>>>
    
    export type ApiCancelBidMutationError = ErrorType<BackendErrorEntity>

    export const useApiCancelBid = <TError = ErrorType<BackendErrorEntity>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiCancelBid>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof fetchApiInstance>}
): UseMutationReturnType<
        Awaited<ReturnType<typeof apiCancelBid>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getApiCancelBidMutationOptions(options);

      return useMutation(mutationOptions);
    }
    